import {
  Button,
  ButtonGroup,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import type { AssignmentFormData } from '../../types/assignmentTypes';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function EditPointInTimeWorkflowModal() {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { id } = useParams();
  const { watch } = useFormContext<AssignmentFormData>();
  const navigate = useNavigate();
  const location = useLocation();

  const { simpleType } = watch();

  useEffect(() => {
    const isInstance = location.pathname.includes('instance');

    if (!isInstance && id && simpleType === 'pointInTime') {
      onOpen();
    }
  }, [location, simpleType]);

  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />

      <ModalContent paddingTop={12} paddingX={10} paddingBottom={8}>
        <ModalBody>
          <VStack textAlign="center" marginY={10} spacing={4}>
            <Image src="/public/images/toggles.png" alt="Form Toggles" />

            <Text fontSize="20px" fontWeight={600}>
              {t('admin.assignments.edit.direct.modal.title')}
            </Text>

            <Text fontSize="14px" fontWeight={500}>
              {t('admin.assignments.edit.direct.modal.description')}
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter display="flex" justifyContent="center">
          <ButtonGroup gap={4}>
            <Button variant="createCancel" onClick={() => navigate(-1)}>
              {t('global.actions.cancel')}
            </Button>

            <Button variant="solid" onClick={onClose}>
              {t('admin.assignments.edit.direct.modal.confirm')}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
